<template>
  <div ref="element" class="p-3 text-center d-flex justify-content-center">
    <v-loader v-if="isLoading" />
  </div>
</template>

<script>
import ApiClient from "@/lib/api-client"

export default {
  props: {
    queryParams: { type: Object, default: () => ({}) },
    path: { type: String, required: true },
    listKey: { type: String, required: true },
    initPage: { type: Number, default: 1 }
  },

  data() {
    return {
      isVisible: false,
      isLoading: false,
      isFinished: false,
      observer: null,
      page: this.initPage
    }
  },

  mounted() {
    this.setupInfiniteLoadObserver()
  },

  beforeDestroy() {
    this.observer?.disconnect()
  },

  methods: {
    setupInfiniteLoadObserver() {
      this.observer = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting) {
          this.fetchItems()
        }
      })
      this.observer.observe(this.$refs["element"])
    },

    fetchItems() {
      if (!this.isLoading && !this.isFinished) {
        this.isLoading = true
        const page = this.page

        ApiClient.get(this.path, {
          params: { ...this.queryParams, page }
        })
          .then(res => {
            const list = res.data[this.listKey]

            const { pagination, ...data } = res.data
            this.$emit("loaded", { page, list, ...data })
            this.page++

            if (
              (!pagination.totalPages && list.length === 0) ||
              pagination.currentPage >= pagination.totalPages
            ) {
              this.isFinished = true
            }
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    }
  }
}
</script>
